// Static fields for the first column for invoice mapping
export const invoiceDbMappingFields = {
    // "Invoice Number": {
    //     key: "invoice_number",
    //     description: "",
    //     controls: "",
    //     name: "Invoice Number",
    //     required: true,
    // },
    // "Invoice Date": {
    //     key: "invoice_date",
    //     description: "",
    //     controls: "",
    //     name: "Invoice Date",
    //     required: false,
    // },
    "Order Number": {
        key: "order_number",
        description: "",
        controls: "",
        name: "Order Number",
        required: true,
    },
    "Article code": {
        key: "article_code",
        description: "",
        controls: "",
        name: "Article code",
        required: true,
    },
    "Custom code": {
        key: "custom_code",
        description: "",
        controls: "",
        name: "Custom code",
        required: false,
    },
    "Quantity": {
        key: "quantity",
        description: "",
        controls: "",
        name: "Quantity",
        required: true,
    },
    "Price": {
        key: "price",
        description: "",
        controls: "",
        name: "Price",
        required: true,
    },
    // "Currency": {
    //     key: "currency",
    //     description: "",
    //     controls: "",
    //     name: "Currency",
    //     required: false,
    // },
    "Description": {
        key: "description",
        description: "",
        controls: "",
        name: "Description",
        required: false,
    },
    // "Expected Delivery date": {
    //     key: "expected_delivery_date",
    //     description: "",
    //     controls: "",
    //     name: "Expected Delivery date",
    //     required: false,
    // },
    // "Supplier Code": {
    //     key: "supplier_code",
    //     description: "",
    //     controls: "",
    //     name: "Supplier Code",
    //     required: true,
    // },
    "Production lot": {
        key: "production_lot",
        description: "",
        controls: "",
        name: "Production lot",
        required: false,
    },
    "Number of Box": {
        key: "number_of_box",
        description: "",
        controls: "",
        name: "Number of Box",
        required: false,
    },
    "Pallet id": {
        key: "number_pallets",
        description: "",
        controls: "",
        name: "Pallet id",
        required: false,
    },
    "Gross weight": {
        key: "gross_weight",
        description: "",
        controls: "",
        name: "Gross weight",
        required: false,
    },
    "Net weight": {
        key: "net_weight",
        description: "",
        controls: "",
        name: "Net weight",
        required: false,
    },
    "Container id": {
        key: "container_id",
        description: "",
        controls: "",
        name: "Container id",
        required: false, // required only if boat shipment (we’ll handle in validation)
    },
    //  "Shipping mode": {
    //     key: "shipping_mode",
    //     description: "",
    //     controls: "",
    //     name: "Shipping mode",
    //     required: false,
    // },
    //   "B/L Number": {
    //     key: "bill_lading_number",
    //     description: "",
    //     controls: "",
    //     name: "B/L Number",
    //     required: false,
    // },

    // "Is Exported": {
    //     key: "isExported",
    //     description: "",
    //     controls: "",
    //     name: "Is Exported",
    //     required: false,
    // },
    // "Processed": {
    //     key: "processed",
    //     description: "",
    //     controls: "",
    //     name: "Processed",
    //     required: false,
    // },
    // "Insertion Date": {
    //     key: "insertion_date",
    //     description: "",
    //     controls: "",
    //     name: "Insertion Date",
    //     required: false,
    // },
};
export const dateFormats = [
    "YYYY-MM-DD",
    "DD-MM-YYYY",
    "MM/DD/YYYY",
    "DD/MM/YYYY",
    "D/M/YYYY",
    "YYYY-MM-DD HH:mm:ss",
    "YYYY-MM-DDTHH:mm:ss.SSSSS",
    "YYYY-MM-DDTHH:mm:ss.SSSSSS",
    "YYYY-MM-DDTHH:mm:ss.SSSZ",
    "YYYY-MM-DD HH:mm:ss.SSSSSS",
];

export const fieldKeywords = [
    "invoice_number",
    "invoice_date",
    "order_number",
    "article_code",
    "quantity",
    "price",
    "currency",
    "expected_delivery_date",
    "supplier_code",
    "production_lot",
    "insertion_date"
];
